export const SCENE_MAP = {
  // 个人客户编辑
  individual_customer_info_v2: {
    page: 'form',
  },
  // 企业客户编辑
  enterprise_customer_info_v2: {
    page: 'form',
  },
}
